import { render, staticRenderFns } from "./PatternsFilterSheet.vue?vue&type=template&id=0dd2f06f"
import script from "./PatternsFilterSheet.vue?vue&type=script&lang=js"
export * from "./PatternsFilterSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports